// Semicircular SVG gauge for the Overall Project Intelligence Score (0-100).
export function IntelligenceScoreGauge({ score = 0, label = "PROJECT INTELLIGENCE", testid }) {
  const pct = Math.max(0, Math.min(100, Number(score) || 0));
  const R = 66;
  const C = Math.PI * R;
  const dash = (pct / 100) * C;
  const color = pct >= 80 ? "#10B981" : pct >= 60 ? "#C20511" : pct >= 40 ? "#FBBF24" : "#F43F5E";
  const rating = pct >= 80 ? "Advanced · Drill-Ready" : pct >= 60 ? "Target Definition" : pct >= 40 ? "Early Exploration" : "Reconnaissance";
  return (
    <div data-testid={testid} className="p-5 rounded-lg bg-card border border-border flex flex-col">
      <span className="text-[10px] font-mono uppercase tracking-[0.18em] text-muted-foreground">{label}</span>
      <div className="relative flex flex-col items-center mt-1">
        <svg viewBox="0 0 160 92" className="w-full max-w-[240px]">
          <path d="M14 86 A66 66 0 0 1 146 86" fill="none" stroke="#334155" strokeOpacity="0.35" strokeWidth="10" strokeLinecap="round" />
          <path d="M14 86 A66 66 0 0 1 146 86" fill="none" stroke={color} strokeWidth="10" strokeLinecap="round"
            strokeDasharray={`${dash} ${C}`} style={{ transition: "stroke-dasharray 0.7s ease" }} />
        </svg>
        <div className="-mt-9 flex flex-col items-center">
          <span className="text-[40px] leading-none font-mono font-bold" style={{ color }} data-testid={testid ? `${testid}-value` : undefined}>{Math.round(pct)}</span>
          <span className="text-[11px] text-muted-foreground mt-0.5">out of 100</span>
        </div>
      </div>
      <span className="mt-3 text-center text-xs font-semibold" style={{ color }}>{rating}</span>
    </div>
  );
}
